// src/composables/useSeoMeta.ts
import { onMounted } from 'vue'

interface MetaTag {
  name?: string
  property?: string
  content: string
}

interface SeoOptions {
  title?: string
  meta?: MetaTag[]
}

export function useSeoMeta(options: SeoOptions) {
  onMounted(() => {
    if (options.title) {
      document.title = options.title
    }

    if (options.meta && Array.isArray(options.meta)) {
      options.meta.forEach((tag) => {
        const selector = tag.name ? `meta[name="${tag.name}"]` : `meta[property="${tag.property}"]`
        let element = document.querySelector(selector)
        
        if (!element) {
          element = document.createElement('meta')
          document.head.appendChild(element)
        }
        
        if (tag.name) element.setAttribute('name', tag.name)
        if (tag.property) element.setAttribute('property', tag.property)
        element.setAttribute('content', tag.content)
      })
    }
  })
}